module.exports = __webpack_public_path__ + "img/Croatia.af8f3c25.svg";